import { Form } from 'antd'
import React from 'react'
import { OneButton } from '@yy/one-ui'

function hocDisabledWithFormError<
  T extends {
    disabled?: boolean
  }
>(WrappedComponent: React.ComponentType<T>) {
  return function ({ disabled, ...props }: T) {
    return (
      <Form.Item noStyle shouldUpdate>
        {({ getFieldsError }) => {
          const hasError = getFieldsError()?.some((item) => item.errors.length)
          return <WrappedComponent disabled={disabled || hasError} {...(props as T)} />
        }}
      </Form.Item>
    )
  }
}

export default hocDisabledWithFormError

export const DisabledWithFormErrorButton = hocDisabledWithFormError(OneButton)
